import { useCallback, useEffect, useState } from 'react';
import { dashboardService } from '../services';
import type { RemindersByVaccine } from '../services/dashboardService';
import { getApiErrorMessage } from '../lib/apiError';

/** Loads the reminders-by-vaccine breakdown for the dashboard card. */
export function useRemindersByVaccine() {
  const [data, setData] = useState<RemindersByVaccine | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      setData(await dashboardService.getRemindersByVaccine());
    } catch (err) {
      setError(getApiErrorMessage(err, 'Could not load reminders by vaccine'));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return { data, loading, error, reload };
}
